import React from "react";
import { View, StyleSheet } from "@react-pdf/renderer";
import TableRow from "./TableRow";

const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: "row",
        flexWrap: "wrap",
    },
});

const ItemsTable = ({ tableData } ) => (
    <View style={styles.tableContainer}>
        {/*<TableHeader />*/}
        <TableRow items={tableData.items} />
        {/*<TableFooter items={data.items} />*/}
    </View>
);

export default ItemsTable;